var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.13,
    height: 69.721,
    viewBox: "0 0 57.13 69.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y2: 57.721,
    transform: "translate(45.13 0)",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    y2: 57.721,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.df3da9ae.svg";
export { ForwardRef as ReactComponent };